import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Form, FormGroup, FormControl, InputGroup, Modal, Button } from 'react-bootstrap'

import rest from '../../lib/rest'
import md5 from 'blueimp-md5'

import { UserCheck } from 'styled-icons/fa-solid/UserCheck'
import { Key } from 'styled-icons/fa-solid/Key'
import { Exclamation } from 'styled-icons/fa-solid/Exclamation'
import { ArrowLeft } from 'styled-icons/fa-solid/ArrowLeft'


class ChangePassword extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      user: '',
      userAlert:'',
      passAlert:'',
      newPassAlert: '',
      alert: ''
    }
  }

  componentDidMount() {
    this.userInput.focus()
  }

  goback = () => this.props.onModeChange('signin')

  clearAlert = () => this.setState({ alert: '',  userAlert: '', passAlert: '', newPassAlert: '' })
  alert = m => {
    this.setState({ alert: m })
    setTimeout(this.clearAlert, 3000)
  }

  setValue = e => this.setState({ [e.target.id]: e.target.value })
  onEnter = e => (e.charCode === 13) ? this.submit(e) : null

  submit = e => {
    e.preventDefault()

    const { user } = this.state
    const pass = this.passInput.value
    const newPass = this.newPassInput.value

    if (!user) {
      this.userInput.focus()
      return this.setState({ newPassAlert: '', userAlert: 'user id required', passAlert: '' })
    }
    if (!pass) {
      this.passInput.focus()
      return this.setState({ newPassAlert: '', userNotice: '', passNotice: 'password required' })
    }
    if (!newPass) {
      this.newPassInput.focus()
      return this.setState({ newPassAlert: 'New password required', userAlert: '', passAlert: '' })
    }

    const data = JSON.stringify({ user: user, password: md5(pass), newPassword: md5(newPass) })
    rest.userChange(data).then(res => {
      if (res.status === 'fail') {
        this.alert(res.error)
      } else {
        this.goback()
      }
    })
  }

  render() {
    const { user, newPassAlert, userAlert, passAlert, alert } = this.state

    return (
      <Modal.Dialog dialogClassName='modal-login'>
        <div className='text-xs-center bg-danger p-y-4'>
          <span className='font-size-18 line-height-1'>Change password</span>
        </div>
        { !!alert ? <div className='alert alert-danger'>{alert}</div> : null }

        <Form className='p-a-4'>
          <FormGroup controlId='user' className={ cx({ 'has-warning': !!userAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><UserCheck size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.userInput = r} autoComplete='off' type='text' value={user}
                placeholder='user id' onChange={this.setValue} onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{userAlert}</small>
          </FormGroup>

          <FormGroup className={ cx({ 'has-warning': !!passAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><Key size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.passInput = r} type='password' placeholder='password' onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{passAlert}</small>
          </FormGroup>

          <FormGroup className={ cx({ 'has-warning': !!newPassAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><Exclamation size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.newPassInput = r} autoComplete='off' type='password' placeholder='new password' onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{newPassAlert}</small>
          </FormGroup>

          <Button bsSize='lg' bsStyle='danger' className='btn-block m-t-3' onClick={this.submit}>Apply</Button>
          <Button className='btn-link' onClick={this.goback}><ArrowLeft size={14}/> Back</Button>
        </Form>

      </Modal.Dialog>
    )
  }
}

ChangePassword.propTypes = {
    strings: PropTypes.object
}

export default ChangePassword



// WEBPACK FOOTER //
// ./src/components/auth/ChangePassword.js